// @flow
import React, { Component } from "react";
import PropTypes from "prop-types";
import { history } from "./stores/configureStore";
import { Route, Switch } from "react-router-dom";
import { ConnectedRouter } from "connected-react-router";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { Layout, Row, BackTop, message } from "antd";
import ReactGA from "react-ga";
import * as actions from "./actions";
import PrivateRoute from "./components/privateroute";
import Nav from "./components/nav";
import Home from "./components/home";
import GridView from "./components/gridview";
import DealerPortalAccess from "./components/dealerportalaccess";
import LoginPage from "./components/loginpage";
import ForgotPasswordPage from "./components/forgotpassword";
import type { State } from "./types/store";
import type { Entities } from "./types/entities";
import type { User } from "./reducers/auth";
import "./App.css";

const { Content, Footer } = Layout;

type Props = {
  languagesData: Entities,
  browserLanguageId: string,
  user: User,
  isFetching: boolean,
  loginHasError: boolean,
  forgotPasswordMessage: boolean,
  loginError: string,
  filtersByTypologyHasError: boolean,
  filtersByTypologyError: string,
  mainFiltersHasError: boolean,
  mainFiltersError: string,
  itemsHasError: boolean,
  itemsError: string,
  languageHasError: boolean,
  languageError: string,
  onSetBrowserLanguages: Function,
  onGetLanguages: Function,
  onForgotPasswordSuccess: Function
};

class App extends Component<Props> {
  componentDidMount() {
    const {
      languagesData,
      browserLanguageId,
      onSetBrowserLanguages,
      onGetLanguages
    } = this.props;
    // get browser language
    let locale =
      (navigator.languages && navigator.languages[0]) ||
      navigator.language ||
      navigator.userLanguage ||
      "en-US";

    if (browserLanguageId === null) {
      onSetBrowserLanguages(locale);
      console.log("locale ", locale);
    }
    if (languagesData.all.length === 0) {
      // get app languages
      onGetLanguages();
    }

    // avvio analytics per questa pagina
    ReactGA.pageview(history.location.pathname);
    // e tutte le pagine successive
    history.listen((location, action) => {
      // ReactGA.set({ page: location.pathname });
      ReactGA.pageview(location.pathname);
      console.log("location", location.pathname);
    });
  }

  componentDidUpdate() {
    const {
      loginHasError,
      forgotPasswordMessage,
      loginError,
      filtersByTypologyHasError,
      filtersByTypologyError,
      mainFiltersHasError,
      mainFiltersError,
      itemsHasError,
      itemsError,
      languageHasError,
      languageError,
      onForgotPasswordSuccess
    } = this.props;

    if (loginHasError) message.error(loginError);
    if (filtersByTypologyHasError) message.error(filtersByTypologyError);
    if (mainFiltersHasError) message.error(mainFiltersError);
    if (itemsHasError) message.error(itemsError);
    if (languageHasError) message.error(languageError);
    if (forgotPasswordMessage)
      message.success(
        "You will recive instructions on how to reset your password",
        2,
        () => onForgotPasswordSuccess("/")
      );
  }

  render() {
    const { user } = this.props;
    return (
      <ConnectedRouter className="App" history={history}>
        <Layout style={{ minHeight: "100vh" }}>
          <Nav {...this.props} />
          <Content className="main-content">
            <BackTop />
            <Switch>
              <Route exact path="/" component={LoginPage} />
              <Route
                exact
                path="/forgot-password"
                component={ForgotPasswordPage}
              />
              <PrivateRoute exact path="/home" component={Home} user={user} />
              <PrivateRoute
                path="/(search|details)"
                component={GridView}
                user={user}
              />
              <Route
                exact
                path="/dealer/:token"
                component={DealerPortalAccess}
              />
              <Route component={NoMatch} />
            </Switch>
          </Content>
          <Footer style={{ textAlign: "center" }}>
            © 2017 CNH Industrial America LLC. Tutti i diritti riservati CASE e
            CNH Capital sono marchi registrati di CNH Industrial America LLC.
          </Footer>
        </Layout>
      </ConnectedRouter>
    );
  }
}

const NoMatch = ({ location }) => (
  <Row className="padding-for-nav" type="flex" align="middle" justify="center">
    <h3>
      No match for <code>{location.pathname}</code>
    </h3>
  </Row>
);

function mapStateToProps(state: State) {
  const {
    user,
    isFetching,
    hasError: loginHasError,
    errorMessage: loginError,
    forgotPasswordMessage
  } = state.auth;
  const {
    hasError: filtersByTypologyHasError,
    errorMessage: filtersByTypologyError
  } = state.filters.byTypology;
  const {
    hasError: mainFiltersHasError,
    errorMessage: mainFiltersError
  } = state.filters.mainFilters;
  const { hasError: itemsHasError, errorMessage: itemsError } = state.items;
  const {
    entities: languagesData,
    browserLanguageId,
    hasError: languageHasError,
    errorMessage: languageError
  } = state.language;
  return {
    languagesData,
    browserLanguageId,
    user,
    isFetching,
    loginHasError,
    loginError,
    forgotPasswordMessage,
    filtersByTypologyHasError,
    filtersByTypologyError,
    mainFiltersHasError,
    mainFiltersError,
    itemsHasError,
    itemsError,
    languageHasError,
    languageError
  };
}

function mapDispatchToProps(dispatch) {
  return {
    onSetBrowserLanguages: bindActionCreators(
      actions.setBrowserLanguage,
      dispatch
    ),
    onGetLanguages: bindActionCreators(actions.getLanguages, dispatch),
    onForgotPasswordSuccess: bindActionCreators(
      actions.redirectToPage,
      dispatch
    )
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(App);

App.propTypes = {
  languagesData: PropTypes.object,
  browserLanguageId: PropTypes.string,
  user: PropTypes.object,
  isFetching: PropTypes.bool,
  loginHasError: PropTypes.bool,
  forgotPasswordMessage: PropTypes.bool,
  loginError: PropTypes.string,
  filtersByTypologyHasError: PropTypes.bool,
  filtersByTypologyError: PropTypes.string,
  mainFiltersHasError: PropTypes.bool,
  mainFiltersError: PropTypes.string,
  itemsHasError: PropTypes.bool,
  itemsError: PropTypes.string,
  languageHasError: PropTypes.bool,
  languageError: PropTypes.string,
  onSetBrowserLanguages: PropTypes.func.isRequired,
  onGetLanguages: PropTypes.func.isRequired,
  onForgotPasswordSuccess: PropTypes.func.isRequired
};



// WEBPACK FOOTER //
// ./src/App.js